import { render, staticRenderFns } from "./projectTitle.vue?vue&type=template&id=58cbd296&scoped=true&"
import script from "./projectTitle.vue?vue&type=script&lang=js&"
export * from "./projectTitle.vue?vue&type=script&lang=js&"
import style0 from "./projectTitle.vue?vue&type=style&index=0&id=58cbd296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbd296",
  null
  
)

export default component.exports